'use client';

import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { pageTypeAtom } from '@core/Atoms/PageTypeAtom';

export const ClientTasks = () => {
  const setPageType = useSetAtom(pageTypeAtom);

  useEffect(() => {
    setPageType('reviews');
  }, []);

  return undefined;
};
